import React from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import {
  AppBar,
  makeStyles,
  Toolbar,
  Box,
  Hidden,
  IconButton,
} from "@material-ui/core";
import Logo from "./Logo";
import MenuNavBar from "./MenuNavBar";
import MenuIcon from "@material-ui/icons/Menu";

const useStyles = makeStyles((theme) => ({
  root: {},
  toolbar: {
    height: 91,
    marginLeft: "6%",
  },
  small: {
    flexGrow: 1,
  },
  big: {
    width: "100%",
  },
  menu: {
    marginLeft: "10%",
  },
  nav: {
    width: "100%",
    paddingRight: "8%",
    minWidth: "80%",
  },
}));

const PublicTopBar = ({ className, onMobileNavOpen, ...rest }) => {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
      color="secondary"
      position="static"
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        <Hidden only={["md", "sm", "xs"]}>
          <Box className={classes.big}>
            <RouterLink to="/">
              <Logo width="100%" />
            </RouterLink>
          </Box>
          <Box className={classes.nav}>
            <MenuNavBar />
          </Box>
        </Hidden>

        <Hidden lgUp>
          <Box className={classes.small}>
            <RouterLink to="/">
              <Logo width="20%" />
            </RouterLink>
          </Box>

          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

export default PublicTopBar;
